import { FEATURE_DATA } from './featureData';
import { ABM_TOOLS_AND_AUTOMATION, ADVANCED_LIST_CRITERIA, ADVANCED_MESSENGER_BOT_BRANCHING_AND_ADVANCED_REPORTING, AI_FORECASTING, AI_MEETING_ASSISTANT, ASSOCIATION_LABELS, AUTOMATIC_LEAD_ROTATION, B2B_CHECKOUT, BOOK_ON_BEHALF_OF_OTHERS, BREEZE_COPILOT, BREEZE_PROSPECTING_AGENT, CALCULATED_PROPERTIES, CALLING, CHANNEL_SWITCHING, COACHING_PLAYLISTS, CODE_SNIPPETS_FOR_CUSTOM_MESSENGER_BOT_ACTIONS, CONVERSATIONAL_BOTS, CONVERSATION_INTELLIGENCE, CONVERSATION_ROUTING, CUSTOM_BOTS_CUSTOM_BRANCHING_LOGIC_AND_ADVANCED_TARGETING, CUSTOM_DEAL_TAG_RULES, CUSTOM_EVENTS, CUSTOM_GOALS, CUSTOM_OBJECTS, CUSTOM_PERMISSION_SETS, CUSTOM_PROPERTIES, CUSTOM_REPORT_BUILDER, CUSTOM_USER_PERMISSIONS, CUSTOM_VIEWS, DATA_MODEL, DEALS, DEAL_APPROVALS, DEAL_JOURNEY_ANALYTICS, DEAL_PIPELINE_AUTOMATION, DEAL_SPLITS, DEAL_SUMMARIES, DEAL_TAGS, DOCUMENTS, DRAGGABLE_CHAT_WIDGET, DUPLICATE_MANAGEMENT, DYNAMIC_SEQUENCES, EMAIL_AND_IN_APP_CHAT, EMAIL_TEMPLATES, EMAIL_TRACKING_AND_NOTIFICATIONS, EMBED_AND_UPDATE_PROPERTIES, E_SIGNATURE, FACEBOOK_MESSENGER_INTEGRATION, FIELD_LEVEL_PERMISSIONS, FORECASTING, FORECAST_ACROSS_TEAM_HIERARCHIES, GMAIL_OUTLOOK_AND_MICROSOFT_EXCHANGE_INTEGRATIONS, GOALS, GUIDED_ACTIONS, HUBSPOT_MOBILE_APP, HUBSPOT_PROVIDED_PHONE_NUMBERS, INTERACTIVE_VOICE_RESPONSE, INVOICES, LEADS, LEAD_FORM_ROUTING, LINKEDIN_CRM_SYNC_INTEGRATION, LINKEDIN_SALES_NAVIGATOR_INTEGRATION, LISTS, LIVE_CHAT, LOGGED_IN_VISITOR_IDENTIFICATION, LOG_IN_AS_ANOTHER_USER, MEETING_SCHEDULER, MOBILE_INBOX, MULTIPLE_CURRENCIES, MULTIPLE_EMAIL_SIGNATURES, ONE_TO_ONE_EMAIL, ONE_TO_ONE_TECHNICAL_SUPPORT, ONE_TO_ONE_VIDEO_MESSAGING, ORGANIZE_TEAMS, PAYMENTS, PAYMENT_LINKS, PERMISSION_SETS, PHONE_SUPPORT, PLAYBOOKS, PREDICTIVE_LEAD_SCORING, PRESETS, PRODUCTS, QUOTES, REPEATING_TASKS_AND_QUEUES, REPORTING_DASHBOARDS, SALESFORCE_CUSTOM_OBJECT_SYNC, SALESFORCE_INTEGRATION, SALES_ANALYTICS, SALES_CONTENT_ANALYTICS, SALES_EMAIL_FREQUENCY_CONTROLS, SALES_WORKSPACE, SCORE_PROPERTIES, SENSITIVE_DATA, SEQUENCES, SHARED_INBOX, SINGLE_SIGN_ON, SLACK_INTEGRATION, SNIPPETS, STANDARD_SANDBOX_ACCOUNT, STRIPE_PAYMENT_PROCESSING, SUBSCRIPTIONS, SYNC_PROPERTIES, TARGET_ACCOUNTS, TARGET_ACCOUNTS_OVERVIEW, TASKS, TASK_CALENDAR_SYNC, TEAMS, TICKET_CREATION_LEAD_QUALIFICATION_AND_MEETING_BOOKING_BOTS, TRACKED_TERMS, TRIGGER_SEQUENCES, USER_MANAGEMENT, WORKFLOWS, WORKFLOW_EXTENSIONS, WORKFLOW_HEALTH_MONITORING } from './features';
const BUILD_PIPELINES_GROUP_ORDER = [{
  parentFeature: FEATURE_DATA[ONE_TO_ONE_EMAIL],
  childrenFeatures: [FEATURE_DATA[CHANNEL_SWITCHING], FEATURE_DATA[GMAIL_OUTLOOK_AND_MICROSOFT_EXCHANGE_INTEGRATIONS], FEATURE_DATA[EMAIL_TRACKING_AND_NOTIFICATIONS], FEATURE_DATA[ONE_TO_ONE_VIDEO_MESSAGING], FEATURE_DATA[MULTIPLE_EMAIL_SIGNATURES]]
}, {
  parentFeature: FEATURE_DATA[EMAIL_TEMPLATES],
  childrenFeatures: [FEATURE_DATA[SALES_CONTENT_ANALYTICS]]
}, {
  parentFeature: FEATURE_DATA[LIVE_CHAT],
  childrenFeatures: [FEATURE_DATA[LOGGED_IN_VISITOR_IDENTIFICATION], FEATURE_DATA[DRAGGABLE_CHAT_WIDGET]]
}, {
  parentFeature: FEATURE_DATA[CONVERSATIONAL_BOTS],
  childrenFeatures: [FEATURE_DATA[TICKET_CREATION_LEAD_QUALIFICATION_AND_MEETING_BOOKING_BOTS], FEATURE_DATA[CUSTOM_BOTS_CUSTOM_BRANCHING_LOGIC_AND_ADVANCED_TARGETING]]
}, {
  parentFeature: FEATURE_DATA[FACEBOOK_MESSENGER_INTEGRATION],
  childrenFeatures: [FEATURE_DATA[ADVANCED_MESSENGER_BOT_BRANCHING_AND_ADVANCED_REPORTING], FEATURE_DATA[CODE_SNIPPETS_FOR_CUSTOM_MESSENGER_BOT_ACTIONS]]
}, {
  parentFeature: FEATURE_DATA[MEETING_SCHEDULER],
  childrenFeatures: [FEATURE_DATA[AI_MEETING_ASSISTANT], FEATURE_DATA[BOOK_ON_BEHALF_OF_OTHERS], FEATURE_DATA[LEAD_FORM_ROUTING]]
}, {
  parentFeature: FEATURE_DATA[SHARED_INBOX],
  childrenFeatures: [FEATURE_DATA[CONVERSATION_ROUTING], FEATURE_DATA[CUSTOM_VIEWS]]
}, {
  parentFeature: FEATURE_DATA[SNIPPETS],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[TASKS],
  childrenFeatures: [FEATURE_DATA[TASK_CALENDAR_SYNC], FEATURE_DATA[REPEATING_TASKS_AND_QUEUES]]
}, {
  parentFeature: FEATURE_DATA[CALLING],
  childrenFeatures: [FEATURE_DATA[HUBSPOT_PROVIDED_PHONE_NUMBERS], FEATURE_DATA[INTERACTIVE_VOICE_RESPONSE]]
}, {
  parentFeature: FEATURE_DATA[BREEZE_PROSPECTING_AGENT],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[LINKEDIN_SALES_NAVIGATOR_INTEGRATION],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[SALES_WORKSPACE],
  childrenFeatures: [FEATURE_DATA[LEADS], FEATURE_DATA[GUIDED_ACTIONS]]
}, {
  parentFeature: FEATURE_DATA[SEQUENCES],
  childrenFeatures: [FEATURE_DATA[DYNAMIC_SEQUENCES]]
}, {
  parentFeature: FEATURE_DATA[TARGET_ACCOUNTS],
  childrenFeatures: [FEATURE_DATA[ABM_TOOLS_AND_AUTOMATION], FEATURE_DATA[TARGET_ACCOUNTS_OVERVIEW]]
}];
const CLOSE_DEALS_GROUP_ORDER = [{
  parentFeature: FEATURE_DATA[BREEZE_COPILOT],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[DEALS],
  childrenFeatures: [FEATURE_DATA[DEAL_PIPELINE_AUTOMATION], FEATURE_DATA[DEAL_TAGS], FEATURE_DATA[CUSTOM_DEAL_TAG_RULES], FEATURE_DATA[DEAL_SUMMARIES], FEATURE_DATA[DEAL_SPLITS], FEATURE_DATA[DEAL_APPROVALS]]
}, {
  parentFeature: FEATURE_DATA[DOCUMENTS],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[HUBSPOT_MOBILE_APP],
  childrenFeatures: [FEATURE_DATA[MOBILE_INBOX]]
}, {
  parentFeature: FEATURE_DATA[PAYMENTS],
  childrenFeatures: [FEATURE_DATA[STRIPE_PAYMENT_PROCESSING], FEATURE_DATA[PAYMENT_LINKS], FEATURE_DATA[SUBSCRIPTIONS], FEATURE_DATA[B2B_CHECKOUT]]
}, {
  parentFeature: FEATURE_DATA[QUOTES],
  childrenFeatures: [FEATURE_DATA[E_SIGNATURE]]
}, {
  parentFeature: FEATURE_DATA[INVOICES],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[REPORTING_DASHBOARDS],
  childrenFeatures: [FEATURE_DATA[SALES_ANALYTICS], FEATURE_DATA[CUSTOM_REPORT_BUILDER], FEATURE_DATA[DEAL_JOURNEY_ANALYTICS]]
}, {
  parentFeature: FEATURE_DATA[PRODUCTS],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[GOALS],
  childrenFeatures: [FEATURE_DATA[CUSTOM_GOALS]]
}, {
  parentFeature: FEATURE_DATA[CONVERSATION_INTELLIGENCE],
  childrenFeatures: [FEATURE_DATA[COACHING_PLAYLISTS], FEATURE_DATA[TRACKED_TERMS]]
}, {
  parentFeature: FEATURE_DATA[FORECASTING],
  childrenFeatures: [FEATURE_DATA[FORECAST_ACROSS_TEAM_HIERARCHIES], FEATURE_DATA[AI_FORECASTING]]
}, {
  parentFeature: FEATURE_DATA[PLAYBOOKS],
  childrenFeatures: [FEATURE_DATA[EMBED_AND_UPDATE_PROPERTIES]]
}];
const CUSTOMER_PLATFORM_GROUP_ORDER = [{
  parentFeature: FEATURE_DATA[CUSTOM_PROPERTIES],
  childrenFeatures: [FEATURE_DATA[CALCULATED_PROPERTIES], FEATURE_DATA[SYNC_PROPERTIES], FEATURE_DATA[SCORE_PROPERTIES], FEATURE_DATA[PREDICTIVE_LEAD_SCORING], FEATURE_DATA[FIELD_LEVEL_PERMISSIONS]]
}, {
  parentFeature: FEATURE_DATA[DATA_MODEL],
  childrenFeatures: [FEATURE_DATA[ASSOCIATION_LABELS]]
}, {
  parentFeature: FEATURE_DATA[CUSTOM_USER_PERMISSIONS],
  childrenFeatures: [FEATURE_DATA[PERMISSION_SETS], FEATURE_DATA[CUSTOM_PERMISSION_SETS]]
}, {
  parentFeature: FEATURE_DATA[SLACK_INTEGRATION],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[USER_MANAGEMENT],
  childrenFeatures: [FEATURE_DATA[TEAMS], FEATURE_DATA[PRESETS], FEATURE_DATA[ORGANIZE_TEAMS], FEATURE_DATA[LOG_IN_AS_ANOTHER_USER], FEATURE_DATA[SINGLE_SIGN_ON]]
}, {
  parentFeature: FEATURE_DATA[ONE_TO_ONE_TECHNICAL_SUPPORT],
  childrenFeatures: [FEATURE_DATA[EMAIL_AND_IN_APP_CHAT], FEATURE_DATA[PHONE_SUPPORT]]
}, {
  parentFeature: FEATURE_DATA[LISTS],
  childrenFeatures: [FEATURE_DATA[ADVANCED_LIST_CRITERIA]]
}, {
  parentFeature: FEATURE_DATA[MULTIPLE_CURRENCIES],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[DUPLICATE_MANAGEMENT],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[LINKEDIN_CRM_SYNC_INTEGRATION],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[SALES_EMAIL_FREQUENCY_CONTROLS],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[SALESFORCE_INTEGRATION],
  childrenFeatures: [FEATURE_DATA[SALESFORCE_CUSTOM_OBJECT_SYNC]]
}, {
  parentFeature: FEATURE_DATA[WORKFLOWS],
  childrenFeatures: [FEATURE_DATA[WORKFLOW_EXTENSIONS], FEATURE_DATA[AUTOMATIC_LEAD_ROTATION], FEATURE_DATA[TRIGGER_SEQUENCES], FEATURE_DATA[WORKFLOW_HEALTH_MONITORING]]
}, {
  parentFeature: FEATURE_DATA[CUSTOM_EVENTS],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[CUSTOM_OBJECTS],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[SENSITIVE_DATA],
  childrenFeatures: []
}, {
  parentFeature: FEATURE_DATA[STANDARD_SANDBOX_ACCOUNT],
  childrenFeatures: []
}];
export const FEATURE_GROUPING_ORDER = {
  buildPipelines: BUILD_PIPELINES_GROUP_ORDER,
  closeDeals: CLOSE_DEALS_GROUP_ORDER,
  customerPlatform: CUSTOMER_PLATFORM_GROUP_ORDER
};